import styles from './CloudDecorations.module.scss';

export function CloudDecorations() {
  return (
    <svg
      className={styles.clouds}
      viewBox="0 0 394 394"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id="cloudGrad1"
          x1="9.63"
          y1="85.94"
          x2="15.32"
          y2="39.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6D4FC" />
          <stop offset="1" stopColor="#FFC2EC" />
        </linearGradient>
        <linearGradient
          id="cloudGrad2"
          x1="312.53"
          y1="58.1"
          x2="312.58"
          y2="-20.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6D4FC" />
          <stop offset="1" stopColor="#FFC2EC" />
        </linearGradient>
        <linearGradient
          id="cloudGrad3"
          x1="256.79"
          y1="69.24"
          x2="271.62"
          y2="24.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6D4FC" />
          <stop offset="1" stopColor="#FFC2EC" />
        </linearGradient>
        <linearGradient
          id="cloudGrad4"
          x1="372.33"
          y1="193.38"
          x2="376.16"
          y2="166.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6D4FC" />
          <stop offset="1" stopColor="#FFC2EC" />
        </linearGradient>
      </defs>

      {/* Top-left cloud */}
      <path
        d="M-32.978 62.1097C-38.7029 65.5484 -40.7872 74.8897 -36.5512 80.0527C-30.9224 86.9254 -21.8549 84.3223 -14.4875 86.522C-8.72424 88.2461 -5.59286 91.6609 0.372131 92.4533C9.36764 93.6444 15.0829 89.8118 21.1343 89.3219C30.8887 88.5391 33.8615 96.1274 46.5504 91.4447C48.3034 90.7964 49.5665 89.2211 51.1994 88.3086C54.398 86.522 57.8176 85.5182 61.2371 84.2022C64.3301 83.0112 67.5191 81.6184 68.7486 78.5398C69.9781 75.4613 69.6227 71.5182 67.1877 69.2657C59.8779 62.5083 56.1942 65.9471 50.0323 63.709C47.0306 62.6188 45.2536 60.4383 42.1895 59.545C35.9027 57.72 28.8379 61.2308 22.3398 61.5478C17.2009 61.7975 12.3357 58.6181 7.31687 57.7056C2.64862 56.8603 -2.01483 60.7361 -8.25357 60.3087C-17.5661 59.6699 -27.0563 58.5509 -32.9732 62.1097H-32.978Z"
        fill="url(#cloudGrad1)"
        stroke="#221D19"
        strokeWidth="2.897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Top-right cloud */}
      <path
        d="M293.528 57.1788C287.847 54.789 282.337 50.923 276.252 49.9779C271.123 49.1813 265.213 50.0409 260.021 50.0544C254.833 50.0679 249.615 48.6862 246.859 44.2801C244.158 39.9551 244.476 34.4779 247.981 30.7784C251.486 27.0789 255.533 25.3732 260.622 25.4542C264.261 25.5082 269.996 26.8269 273.636 26.8044C285.931 26.7324 296.396 17.9517 308.512 20.0535C313.843 20.9761 317.123 22.4658 322.472 23.2534C333.304 24.8511 345.968 16.8401 356.379 20.2515C360.022 21.4487 362.06 23.618 365.829 24.329C367.687 24.6756 370.577 24.8736 372.412 25.3282C378.519 26.8449 381.351 34.8559 379.116 40.7562C376.886 46.6564 371.918 50.77 365.775 52.1156C359.628 53.4613 353.246 52.7952 346.973 52.2912C340.7 51.7871 334.238 51.472 328.265 53.4658C321.902 55.5946 318.734 56.4722 311.926 56.9538C305.783 57.3903 299.443 59.6631 293.528 57.1788Z"
        fill="url(#cloudGrad2)"
        stroke="#221D19"
        strokeWidth="2.897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Middle-right cloud */}
      <path
        d="M224.427 48.9144C219.506 51.8659 217.714 59.8835 221.356 64.3148C226.194 70.2136 233.989 67.9794 240.323 69.8673C245.277 71.3472 247.969 74.278 253.097 74.9582C260.83 75.9805 265.743 72.691 270.945 72.2705C279.33 71.5986 281.886 78.1116 292.794 74.0925C294.301 73.5361 295.387 72.184 296.79 71.4008C299.54 69.8673 302.48 69.0058 305.419 67.8763C308.078 66.854 310.82 65.6586 311.877 63.0163C312.933 60.374 312.628 56.9897 310.535 55.0564C304.251 49.2566 301.084 52.208 295.787 50.2871C293.207 49.3514 291.679 47.4799 289.045 46.7132C283.641 45.1468 277.567 48.1601 271.981 48.4321C267.564 48.6465 263.381 45.9176 259.067 45.1344C255.054 44.4089 251.045 47.7355 245.682 47.3686C237.676 46.8204 229.518 45.8599 224.432 48.9144H224.427Z"
        fill="url(#cloudGrad3)"
        stroke="#221D19"
        strokeWidth="2.897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Bottom-right cloud */}
      <path
        d="M395.533 199.281C391.873 200.537 388.174 202.301 384.333 201.85C380.524 201.403 377.125 198.532 373.308 198.219C370.206 197.962 367.217 199.526 364.104 199.418C359.404 199.257 355.25 195.981 350.556 195.71C349.044 195.623 347.511 195.853 346.017 195.608C341.317 194.844 338.485 188.635 340.978 184.562C342.74 181.683 346.183 180.4 348.797 178.272C351.035 176.455 352.746 173.943 355.298 172.612C360.717 169.783 367.063 173.277 372.96 174.876C377.351 176.067 382.033 176.165 386.472 175.157C389.897 174.381 393.15 172.964 396.573 172.179C399.995 171.394 402.838 171.412 405.89 173.155C408.73 174.778 410.59 177.595 413.498 179.09C417.348 181.071 423.142 180.602 425.943 183.914C428.914 187.426 427.043 193.373 422.94 195.435C418.932 197.449 414.25 196.861 409.933 197.16C405.079 197.494 400.15 197.7 395.536 199.284L395.533 199.281Z"
        fill="url(#cloudGrad4)"
        stroke="#221D19"
        strokeWidth="2.897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
